/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useState, useEffect, Suspense, lazy } from "react";
import CustomerReviews from "../../components/CustomerReviews";
import Loading from "../../components/Loading";
import axios from "axios";

const TestimonialsCarousel = lazy(() => import("../../components/Testimonials"));
const Ratings = lazy(() => import("../../components/Ratings"));
const TestimonialsGetStarted = lazy(() => import("../../components/Testimonials-Get-started"));
const VideoCarousel = lazy(() => import("../../components/VideoCarousel"));


function Testimonials() {
    //Fetching Video Array Data from Json id and Image name must be commom to youtbe url id
    const [urlVideoData, setUrlVideoData] = useState([]);
    useEffect(() => {
        async function getVideoArrayData() {
            try {
                const response = await axios.get(process.env.REACT_APP_WHYSUNWEST_VIDEO_URL);
                const data = response.data.map((item, index) => ({ id: item.id, key: index }));
                setUrlVideoData(data);
            } catch (error) {
                console.error(error);
            }
        }

        getVideoArrayData();
    }, []);

    return (
        <div>
            <CustomerReviews />
            <Suspense fallback={<Loading />}>
                <TestimonialsCarousel />
                <Suspense fallback={<Loading />}>
                    <Ratings />
                    <Suspense fallback={<Loading />}>
                        <TestimonialsGetStarted />
                        <Suspense fallback={<Loading />}>

                            <VideoCarousel subheading="TESTIMONIALS"
                                title="Borrower Videos"
                                videoIdArray={urlVideoData}
                            />

                        </Suspense>
                    </Suspense>
                </Suspense>
            </Suspense>
        </div>
    )
}
export default Testimonials;